export default __webpack_public_path__ + "static/media/1-6.890a2b98.webp";